'use client';

import { c as _c } from "react/compiler-runtime";
import { Memo } from '@legendapp/state/react';
import { type DetailedHTMLProps, type HTMLAttributes } from 'react';
import { ReactiveMotionButton } from '@/components/ReactiveMotionButton';
import { cn } from '@/lib/cn';
import { useCarouselStateState } from './Carousel';
export type CarouselPaginationButtonColor = 'default' | 'white';
export type CarouselPaginationProps = Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'children' | 'color'> & {
  color?: CarouselPaginationButtonColor;
};
export function CarouselPagination(t0) {
  const $ = _c(15);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "default" : t1;
  const carouselState$ = useCarouselStateState();
  let t2;
  if ($[4] !== className) {
    t2 = cn("carousel-pagination flex gap-4 justify-center mx-4 h-3 max-w-full overflow-hidden", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== carouselState$.emblaApi || $[7] !== carouselState$.scrollSnaps || $[8] !== carouselState$.selectedIndex || $[9] !== color) {
    t3 = <Memo>{() => carouselState$.scrollSnaps.get()?.map((_, index) => <ReactiveMotionButton key={index} onClick={() => {
        carouselState$.emblaApi.scrollTo(index);
      }} aria-label={`Show slide${index + 1}`} $className={() => {
        const active = carouselState$.selectedIndex.get() === index;
        return cn("btn rounded-full p-0 border-1 cursor-pointer transition-[width] transition-[width] transition-duration-300 size-3 animate-in fade-in", {
          "bg-accent": !active && color === "default",
          "bg-white": !active && color === "white",
          "bg-secondary": active && color === "default",
          "[.secondary-gradient_&]:bg-white [.bg-secondary_&]:bg-white [.bg-secondary-light_&]:bg-white w-8": active
        });
      }} />)}</Memo>;
    $[6] = carouselState$.emblaApi;
    $[7] = carouselState$.scrollSnaps;
    $[8] = carouselState$.selectedIndex;
    $[9] = color;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== props || $[12] !== t2 || $[13] !== t3) {
    t4 = <div className={t2} {...props}>{t3}</div>;
    $[11] = props;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}